import { useCallback, useState } from 'react'
import { useReactiveVar } from '@apollo/client'
import { useTreasury } from 'contracts/treasury/hooks/use-treasury'
import { balanceVar } from 'shared/store/balance-store'
import { Web3Adress } from 'shared/types'
import { handleCatchAction } from 'shared/utils/handle-catch-action'
import { showNotificationToast } from 'shared/utils/notify'

export const useClaimSubmit = (
  smartContractAddress: Web3Adress,
  smartContractVersion: number
) => {
  const balance = useReactiveVar(balanceVar)
  const [loading, setLoading] = useState(false)

  const treasury = useTreasury(smartContractAddress, smartContractVersion)

  const handleClaim = useCallback(
    // eslint-disable-next-line max-statements
    async (amount: string) => {
      if (!treasury?.withdrawTokens) return

      const requested = Number(amount)
      const deposited = balance.tokenDeposited
      if (!Number.isFinite(requested) || requested <= 0) {
        showNotificationToast({
          title: 'Invalid amount',
          type: 'error'
        })
        return
      }

      if (requested > deposited) {
        showNotificationToast({
          title: 'Insufficient treasury balance',
          description: `You can withdraw up to ${deposited} USDT.`,
          type: 'error'
        })
        return
      }

      setLoading(true)

      showNotificationToast({
        title: 'Approve action in your wallet',
        type: 'info'
      })

      try {
        // NOTE: the full balance withdraws the on-chain deposit as is, so no dust is left behind
        const tx = await treasury.withdrawTokens(
          requested >= deposited ? undefined : amount
        )

        if (!tx) {
          return
        }

        showNotificationToast({
          title: `${amount} USDT withdrawn`,
          type: 'success'
        })
      } catch (error) {
        handleCatchAction(error)
      } finally {
        setLoading(false)
      }
    },
    [treasury, balance.tokenDeposited]
  )

  return { handleClaim, loading }
}
